import React, { useState } from 'react'
import {
  MdClose,
  MdDashboard,
  MdHistory,
  MdLogout,
  MdRateReview,
  MdWarningAmber
} from 'react-icons/md'
import { FaMoneyCheckAlt } from 'react-icons/fa'
import { RxHamburgerMenu, RxHome, RxPerson } from 'react-icons/rx'
import { NavLink, useNavigate } from 'react-router-dom'

const navItems = [
  {
    label: 'Dashboard',
    to: '/dashboard',
    icon: MdDashboard
  },
  {
    label: 'Loan Applications',
    to: '/loan_applications',
    icon: RxHome
  },
  {
    label: 'Loan Reviews',
    to: '/loan_reviews',
    icon: MdRateReview
  },
  {
    label: 'Disbursements',
    to: '/disbursements',
    icon: FaMoneyCheckAlt
  },
  {
    label: 'Tenants',
    to: '/tenants',
    icon: RxPerson
  },
  {
    label: 'Transactions',
    to: '/transaction_history',
    icon: MdHistory
  },
  {
    label: 'Physical Verification',
    to: '/physical-verification',
    icon: MdHistory
  },
  {
    label: 'Overdue Loans',
    to: '/overdue_loans',
    icon: MdWarningAmber
  }
]

export default function Navbar() {
  const [openSideNav, setOpenSideNav] = useState(false)
  const navigate = useNavigate()

  const logout = () => {
    localStorage.removeItem('access_token')
    setOpenSideNav(false)
    navigate('/', { replace: true })
  }

  const navLinkClass = ({ isActive }) => `
    group
    flex
    items-center
    gap-3
    rounded-xl
    px-3.5
    py-3
    text-sm
    font-semibold
    transition
    ${
      isActive
        ? 'bg-white text-[#101828] shadow-sm'
        : 'text-slate-300 hover:bg-white/10 hover:text-white'
    }
  `

  const NavContent = ({ mobile = false }) => (
    <>
      <div className="px-1">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-green-500 text-lg font-black text-white shadow-sm">
            R
          </div>
          <div>
            <p className="text-lg font-bold tracking-tight text-white">RentHub</p>
            <p className="text-[11px] font-medium uppercase tracking-[0.2em] text-slate-400">
              Admin Console
            </p>
          </div>
        </div>
      </div>

      <div className="my-6 h-px bg-white/10" />

      <nav className="flex flex-1 flex-col gap-1.5">
        {navItems.map(item => {
          const Icon = item.icon

          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={navLinkClass}
              onClick={() => mobile && setOpenSideNav(false)}
            >
              <Icon className="text-xl shrink-0" />
              <span>{item.label}</span>
            </NavLink>
          )
        })}
      </nav>

      <div className="mt-6 border-t border-white/10 pt-5">
        <button
          type="button"
          onClick={logout}
          className="flex w-full items-center gap-3 rounded-xl px-3.5 py-3 text-sm font-semibold text-slate-300 transition hover:bg-red-500/10 hover:text-red-300"
        >
          <MdLogout className="text-xl" />
          Logout
        </button>

        <p className="mt-5 px-3 text-[11px] leading-5 text-slate-500">
          RentHub is a product of Rivmev Services.
        </p>
      </div>
    </>
  )

  return (
    <>
      <aside className="sticky top-0 hidden h-screen w-[17rem] min-w-[17rem] shrink-0 flex-col bg-[#101828] px-5 py-6 font-[Satoshi] lg:flex">
        <NavContent />
      </aside>

      <header className="fixed inset-x-0 top-0 z-40 flex h-16 items-center justify-between border-b border-gray-200 bg-white/95 px-5 backdrop-blur lg:hidden">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-green-600 font-black text-white">
            R
          </div>
          <div>
            <p className="font-bold leading-4 text-gray-900">RentHub</p>
            <p className="text-[10px] uppercase tracking-[0.16em] text-gray-400">Admin</p>
          </div>
        </div>

        <button
          type="button"
          onClick={() => setOpenSideNav(true)}
          className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 text-gray-700"
          aria-label="Open navigation"
        >
          <RxHamburgerMenu className="text-xl" />
        </button>
      </header>

      {openSideNav && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <button
            type="button"
            aria-label="Close navigation backdrop"
            onClick={() => setOpenSideNav(false)}
            className="absolute inset-0 bg-black/45"
          />

          <aside className="relative flex h-full w-[17rem] flex-col bg-[#101828] px-5 py-6 shadow-2xl">
            <button
              type="button"
              onClick={() => setOpenSideNav(false)}
              className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 text-white"
              aria-label="Close navigation"
            >
              <MdClose className="text-xl" />
            </button>

            <NavContent mobile />
          </aside>
        </div>
      )}
    </>
  )
}
